export function parseDollars(n: string | number | null) {
  if (typeof n === "string") {
    return parseFloat(n.replace(/,/g, "").replace(/[^0-9\.]+/, ""))
  } else if (typeof n === "number") {
    return n
  } else {
    return NaN
  }
}

export function formatDollars(n: number) {
  if (isNaN(n)) return "Unknown"
  return "$" + Number(n).toFixed(2)
}
